import { useState } from 'react';
import { supabase } from '@/lib/supabase';
import { useToast } from '@/hooks/use-toast';

export const useUpload = () => {
    const [isUploading, setIsUploading] = useState(false);
    const { toast } = useToast();

    const uploadImage = async (file: File, bucket: string = 'images'): Promise<string | null> => {
        setIsUploading(true);
        try {
            const fileExt = file.name.split('.').pop();
            const fileName = `${Math.random().toString(36).substring(2, 15)}_${Date.now()}.${fileExt}`;
            const filePath = `${fileName}`;

            const { error: uploadError } = await supabase.storage
                .from(bucket)
                .upload(filePath, file);

            if (uploadError) {
                throw uploadError;
            }

            const { data } = supabase.storage
                .from(bucket)
                .getPublicUrl(filePath);

            return data.publicUrl;
        } catch (error: any) {
            console.error('Erro no upload:', error);
            toast({
                title: "Erro no upload",
                description: "Não foi possível enviar a imagem. Tente novamente.",
                variant: "destructive"
            });
            return null;
        } finally {
            setIsUploading(false);
        }
    };

    /**
     * Converts a base64 string to a File object
     */
    const base64ToFile = async (base64Url: string, filename: string): Promise<File> => {
        const res = await fetch(base64Url);
        const blob = await res.blob();
        return new File([blob], filename, { type: blob.type });
    };

    return {
        uploadImage,
        base64ToFile,
        isUploading
    };
};
